import { Component, EventEmitter, Output, OnInit, inject } from '@angular/core';
import { ButtonSize, ButtonState, ButtonType } from '../../../../../../assets/types/dtoTypes';
import { Router } from '@angular/router';
import { BreakpointsService, BIPPERZ_BREAKPOINTS } from '../../../../../shared/services/breakpoint.service';
import {ButtonComponent} from "../../../../../shared/button/button.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-password-reset-success-form',
  templateUrl: './password-reset-success-form.component.html',
  styleUrls: ['./password-reset-success-form.component.scss'],
  imports: [
    ButtonComponent,
    TranslateModule
  ],
  standalone: true
})
export class PasswordResetSuccessFormComponent implements OnInit {
  private router = inject(Router);
  private breakpointsService = inject(BreakpointsService);

  @Output() goToLogin = new EventEmitter<void>();

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  protected isMobile: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.breakpointsService.observe( [ BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down ] ).subscribe( (result ) => {
      this.isMobile = result.s || result.m_down;
    } );
  }

  navigateToLogin() {
    this.goToLogin.emit();
    this.router.navigate( [ '/login' ] );

  }
}
